import { useState } from 'react';
import '../css/UserEditModal.css';

const CustomerAddRouteModal = ({ theme, customerList, addressBook, edit, customer, isOpen, onClose, onSubmit }) => {

    const [error, setError] = useState('');

    const [formData, setFormData] = useState({
        id:                   edit ? customer.id : '',
        customer_id:          edit ? customer.customer_id : customer.id,
        collection_address_id: edit ? (customer.collection_address_id || '') : (addressBook.find((item) => item.company === customer.company && item.address === customer.address && item.postcode === customer.postcode)?.id || ''),
        delivery_address_id:   edit ? (customer.delivery_address_id || '') : '',
        company_name:         customer.company_name || customer.company || '',
        address:              customer.address || '',
        postcode:             customer.postcode || '',
        route_name:           edit ? customer.route_name : '',
        price:                edit ? customer.price : '',
        invoice_customer_id:  edit ? customer.invoice_customer_id : '',
        delivery_instructions: edit ? customer.delivery_instructions : '',
        mon:                 edit ? customer.mon : false,
        tue:                 edit ? customer.tue : false,
        wed:                 edit ? customer.wed : false,
        thu:                 edit ? customer.thu : false,
        fri:                 edit ? customer.fri : false,
        sat:                 edit ? customer.sat : false,
        sun:                 edit ? customer.sun : false,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleAddressChange = (type, value) => {
        const selected = addressBook.find((item) => String(item.id) === value);
        setFormData((previous) => ({
            ...previous,
            [`${type}_address_id`]: value,
            ...(type === 'delivery' && selected ? {
                company_name: selected.company,
                address: selected.address,
                postcode: selected.postcode,
            } : {}),
        }));
    };

    const handleSubmit = () => {
        if (!formData.route_name) {
            setError('Route name is required');
            return;
        }
        if (!formData.collection_address_id || !formData.delivery_address_id) {
            setError('Collection and delivery addresses are required');
            return;
        }
        setError('');
        onSubmit(formData);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div id={theme} className="overlay">
            <div className="modal-container customer-route-modal">
                <h2>{edit ? 'Edit' : 'Add'} Delivery Point — {customer.company || customer.company_name}</h2>
                <form className="form two-column">

                    <div className="input-group">
                        <label>Collection Address *</label>
                        <select className="input" value={formData.collection_address_id} onChange={(event) => handleAddressChange('collection', event.target.value)}>
                            <option value="">Select collection address...</option>
                            {addressBook.map((item) => <option key={item.id} value={item.id}>{item.friendly_name}</option>)}
                        </select>
                    </div>

                    <div className="input-group">
                        <label>Delivery Address *</label>
                        <select className="input" value={formData.delivery_address_id} onChange={(event) => handleAddressChange('delivery', event.target.value)}>
                            <option value="">Select delivery address...</option>
                            {addressBook.map((item) => <option key={item.id} value={item.id}>{item.friendly_name}</option>)}
                        </select>
                    </div>

                    {/* Delivery Point Name */}
                    <div className="input-group">
                        <label>Delivery Name</label>
                        <input
                            type="text"
                            name="company_name"
                            placeholder='Name for this delivery point'
                            value={formData.company_name}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>

                    {/* Route Name */}
                    <div className="input-group">
                        <label>Route Name *</label>
                        <input
                            type="text"
                            name="route_name"
                            placeholder='e.g. Manchester AM, Liverpool PM'
                            value={formData.route_name}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>

                    {/* Costings */}
                    <div className="input-group">
                        <label>Costings £</label>
                        <input
                            type="text"
                            name="price"
                            placeholder='100.00'
                            value={formData.price}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>

                    {/* Invoice To */}
                    <div className="input-group">
                        <label>Invoice To</label>
                        <select
                            name="invoice_customer_id"
                            value={formData.invoice_customer_id}
                            onChange={handleInputChange}
                            className="input"
                        >
                            <option value="">Same as customer</option>
                            {customerList.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.company}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Delivery Instructions */}
                    <div className="input-group" style={{ gridColumn: '1 / -1' }}>
                        <label>Delivery Instructions</label>
                        <textarea
                            name="delivery_instructions"
                            placeholder='Standing instructions for this delivery point...'
                            value={formData.delivery_instructions}
                            onChange={handleInputChange}
                            className="input"
                            rows={3}
                        />
                    </div>

                    {/* Delivery Days */}
                    <div className="input-group" style={{ gridColumn: '1 / -1' }}>
                        <label>Delivery Days</label>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            {[
                                ['mon', 'Mon'],
                                ['tue', 'Tue'],
                                ['wed', 'Wed'],
                                ['thu', 'Thu'],
                                ['fri', 'Fri'],
                                ['sat', 'Sat'],
                                ['sun', 'Sun'],
                            ].map(([key, label]) => (
                                <button
                                    key={key}
                                    type="button"
                                    onClick={() =>
                                        setFormData(prev => ({
                                            ...prev,
                                            [key]: !prev[key],
                                        }))
                                    }
                                    style={{
                                        padding: '6px 12px',
                                        borderRadius: '999px',
                                        border: '1px solid #00a2ff',
                                        backgroundColor: formData[key] ? '#00a2ff' : 'transparent',
                                        color: formData[key] ? '#fff' : '#00a2ff',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>

                </form>

                {error && <p style={{ display: 'flex', color: 'red', justifyContent: 'center' }}>{error}</p>}

                <div className="button-group">
                    <button onClick={handleSubmit} className="submit-button">
                        {edit ? 'Save Changes' : 'Add Delivery Point'}
                    </button>
                    <button onClick={onClose} className="close-button">
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomerAddRouteModal;
